export default "assets/images/icons/contact-d7804932.svg";